import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 全局状态
    loading: false,
    systemInfo: {
      title: '门户网站',
      version: '1.0.0'
    }
  },
  mutations: {
    SET_LOADING (state, loading) {
      state.loading = loading
    },
    SET_SYSTEM_INFO (state, info) {
      state.systemInfo = { ...state.systemInfo, ...info }
    }
  },
  actions: {
    setLoading ({ commit }, loading) {
      commit('SET_LOADING', loading)
    },
    setSystemInfo ({ commit }, info) {
      commit('SET_SYSTEM_INFO', info)
    }
  },
  getters: {
    isLoading: state => state.loading,
    systemInfo: state => state.systemInfo
  },
  modules: {
    user
  }
})
